var _sentryCollisionFreeGlobalObject = typeof window === "undefined" ? global : window;
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"fdbc58ac376d20b47eb4a5329d47c9936fc46d1e-5086"};
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "";

import * as Sentry from "@sentry/nextjs";

const SENTRY_EXCLUDED_PATHS = ["/health-check"];

if (process.env.sentryDsn !== undefined) {
  Sentry.init({
    tunnel: process.env.sentryTunnel,
    dsn: process.env.sentryDsn,
    environment: process.env.environment,
    tracesSampler: (samplingContext) => {
      const path = samplingContext.location?.pathname;
      if (SENTRY_EXCLUDED_PATHS.includes(path)) {
        return 0.0;
      }

      return 0.2;
    },
    beforeSendTransaction(event) {
      if (event.user) {
        delete event.user.ip_address;
        delete event.user.email;
      }
      return event;
    },
    beforeSend(event) {
      if (event.user) {
        delete event.user.ip_address;
        delete event.user.email;
      }
      return event;
    },
    ignoreErrors: [/.*ReaderArticleFinderJS\.adoptableArticle.*/],
  });
}
